/* eslint-disable react-refresh/only-export-components */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {};
export var ApplyPolicy;
(function (ApplyPolicy) {
    ApplyPolicy["AfterResolver"] = "AFTER_RESOLVER";
    ApplyPolicy["BeforeResolver"] = "BEFORE_RESOLVER";
    ApplyPolicy["Validation"] = "VALIDATION";
})(ApplyPolicy || (ApplyPolicy = {}));
export var ConsentType;
(function (ConsentType) {
    ConsentType["Email"] = "EMAIL";
    ConsentType["Mail"] = "MAIL";
    ConsentType["Newsletter"] = "NEWSLETTER";
    ConsentType["Sms"] = "SMS";
    ConsentType["Unknown"] = "UNKNOWN";
})(ConsentType || (ConsentType = {}));
export var Country;
(function (Country) {
    Country["Ad"] = "AD";
    Country["Ae"] = "AE";
    Country["Af"] = "AF";
    Country["Ag"] = "AG";
    Country["Al"] = "AL";
    Country["Am"] = "AM";
    Country["Ao"] = "AO";
    Country["Ar"] = "AR";
    Country["At"] = "AT";
    Country["Au"] = "AU";
    Country["Az"] = "AZ";
    Country["Ba"] = "BA";
    Country["Bb"] = "BB";
    Country["Bd"] = "BD";
    Country["Be"] = "BE";
    Country["Bf"] = "BF";
    Country["Bg"] = "BG";
    Country["Bh"] = "BH";
    Country["Bi"] = "BI";
    Country["Bj"] = "BJ";
    Country["Bn"] = "BN";
    Country["Bo"] = "BO";
    Country["Br"] = "BR";
    Country["Bs"] = "BS";
    Country["Bt"] = "BT";
    Country["Bw"] = "BW";
    Country["By"] = "BY";
    Country["Bz"] = "BZ";
    Country["Ca"] = "CA";
    Country["Cd"] = "CD";
    Country["Cf"] = "CF";
    Country["Cg"] = "CG";
    Country["Ch"] = "CH";
    Country["Ci"] = "CI";
    Country["Cl"] = "CL";
    Country["Cm"] = "CM";
    Country["Cn"] = "CN";
    Country["Co"] = "CO";
    Country["Cr"] = "CR";
    Country["Cu"] = "CU";
    Country["Cv"] = "CV";
    Country["Cy"] = "CY";
    Country["Cz"] = "CZ";
    Country["De"] = "DE";
    Country["Dj"] = "DJ";
    Country["Dk"] = "DK";
    Country["Dm"] = "DM";
    Country["Do"] = "DO";
    Country["Dz"] = "DZ";
    Country["Ec"] = "EC";
    Country["Ee"] = "EE";
    Country["Eg"] = "EG";
    Country["Eh"] = "EH";
    Country["Er"] = "ER";
    Country["Es"] = "ES";
    Country["Et"] = "ET";
    Country["Fi"] = "FI";
    Country["Fj"] = "FJ";
    Country["Fo"] = "FO";
    Country["Fr"] = "FR";
    Country["Ga"] = "GA";
    Country["Gb"] = "GB";
    Country["Gd"] = "GD";
    Country["Ge"] = "GE";
    Country["Gh"] = "GH";
    Country["Gi"] = "GI";
    Country["Gm"] = "GM";
    Country["Gn"] = "GN";
    Country["Gq"] = "GQ";
    Country["Gr"] = "GR";
    Country["Gt"] = "GT";
    Country["Gw"] = "GW";
    Country["Gy"] = "GY";
    Country["Hk"] = "HK";
    Country["Hn"] = "HN";
    Country["Hr"] = "HR";
    Country["Ht"] = "HT";
    Country["Hu"] = "HU";
    Country["Id"] = "ID";
    Country["Ie"] = "IE";
    Country["Il"] = "IL";
    Country["In"] = "IN";
    Country["Iq"] = "IQ";
    Country["Ir"] = "IR";
    Country["Is"] = "IS";
    Country["It"] = "IT";
    Country["Jm"] = "JM";
    Country["Jo"] = "JO";
    Country["Jp"] = "JP";
    Country["Ke"] = "KE";
    Country["Kg"] = "KG";
    Country["Kh"] = "KH";
    Country["Ki"] = "KI";
    Country["Km"] = "KM";
    Country["Kp"] = "KP";
    Country["Kr"] = "KR";
    Country["Kw"] = "KW";
    Country["Kz"] = "KZ";
    Country["La"] = "LA";
    Country["Lb"] = "LB";
    Country["Li"] = "LI";
    Country["Lk"] = "LK";
    Country["Lr"] = "LR";
    Country["Ls"] = "LS";
    Country["Lt"] = "LT";
    Country["Lu"] = "LU";
    Country["Lv"] = "LV";
    Country["Ly"] = "LY";
    Country["Ma"] = "MA";
    Country["Mc"] = "MC";
    Country["Md"] = "MD";
    Country["Me"] = "ME";
    Country["Mg"] = "MG";
    Country["Mh"] = "MH";
    Country["Mk"] = "MK";
    Country["Ml"] = "ML";
    Country["Mm"] = "MM";
    Country["Mn"] = "MN";
    Country["Mo"] = "MO";
    Country["Mq"] = "MQ";
    Country["Mr"] = "MR";
    Country["Mt"] = "MT";
    Country["Mu"] = "MU";
    Country["Mv"] = "MV";
    Country["Mw"] = "MW";
    Country["Mx"] = "MX";
    Country["My"] = "MY";
    Country["Mz"] = "MZ";
    Country["Na"] = "NA";
    Country["Ne"] = "NE";
    Country["Ng"] = "NG";
    Country["Ni"] = "NI";
    Country["Nl"] = "NL";
    Country["No"] = "NO";
    Country["Np"] = "NP";
    Country["Nr"] = "NR";
    Country["Nu"] = "NU";
    Country["Nz"] = "NZ";
    Country["Om"] = "OM";
    Country["Pa"] = "PA";
    Country["Pe"] = "PE";
    Country["Pg"] = "PG";
    Country["Ph"] = "PH";
    Country["Pk"] = "PK";
    Country["Pl"] = "PL";
    Country["Pt"] = "PT";
    Country["Py"] = "PY";
    Country["Qa"] = "QA";
    Country["Ro"] = "RO";
    Country["Rs"] = "RS";
    Country["Ru"] = "RU";
    Country["Rw"] = "RW";
    Country["Sa"] = "SA";
    Country["Sc"] = "SC";
    Country["Sd"] = "SD";
    Country["Se"] = "SE";
    Country["Sg"] = "SG";
    Country["Si"] = "SI";
    Country["Sk"] = "SK";
    Country["Sl"] = "SL";
    Country["Sm"] = "SM";
    Country["Sn"] = "SN";
    Country["So"] = "SO";
    Country["Sr"] = "SR";
    Country["Ss"] = "SS";
    Country["St"] = "ST";
    Country["Sv"] = "SV";
    Country["Sy"] = "SY";
    Country["Td"] = "TD";
    Country["Tg"] = "TG";
    Country["Th"] = "TH";
    Country["Tj"] = "TJ";
    Country["Tk"] = "TK";
    Country["Tl"] = "TL";
    Country["Tm"] = "TM";
    Country["Tn"] = "TN";
    Country["To"] = "TO";
    Country["Tr"] = "TR";
    Country["Tt"] = "TT";
    Country["Tv"] = "TV";
    Country["Tw"] = "TW";
    Country["Tz"] = "TZ";
    Country["Ua"] = "UA";
    Country["Ug"] = "UG";
    Country["Us"] = "US";
    Country["Uy"] = "UY";
    Country["Uz"] = "UZ";
    Country["Ve"] = "VE";
    Country["Vn"] = "VN";
    Country["Vu"] = "VU";
    Country["Ws"] = "WS";
    Country["Ye"] = "YE";
    Country["Za"] = "ZA";
    Country["Zm"] = "ZM";
    Country["Zw"] = "ZW";
})(Country || (Country = {}));
export var Currency;
(function (Currency) {
    Currency["Dkk"] = "DKK";
    Currency["Eur"] = "EUR";
    Currency["Nok"] = "NOK";
})(Currency || (Currency = {}));
export var FareCode;
(function (FareCode) {
    FareCode["Adult"] = "ADULT";
    FareCode["Baby"] = "BABY";
    FareCode["Child"] = "CHILD";
    FareCode["Infant"] = "INFANT";
})(FareCode || (FareCode = {}));
export var FareType;
(function (FareType) {
    FareType["CruiseAshore"] = "CRUISE_ASHORE";
    FareType["CruiseOnboard"] = "CRUISE_ONBOARD";
    FareType["Custom"] = "CUSTOM";
    FareType["Economy"] = "ECONOMY";
    FareType["Fjordclub"] = "FJORDCLUB";
    FareType["Flex"] = "FLEX";
})(FareType || (FareType = {}));
export var FlCodeType;
(function (FlCodeType) {
    FlCodeType["AgencyCode"] = "AGENCY_CODE";
    FlCodeType["CustomerCode"] = "CUSTOMER_CODE";
    FlCodeType["PackageCode"] = "PACKAGE_CODE";
    FlCodeType["PromotionCode"] = "PROMOTION_CODE";
    FlCodeType["ReferralCode"] = "REFERRAL_CODE";
    FlCodeType["TicketCode"] = "TICKET_CODE";
    FlCodeType["Unknown"] = "UNKNOWN";
    FlCodeType["VoucherCode"] = "VOUCHER_CODE";
})(FlCodeType || (FlCodeType = {}));
export var Gender;
(function (Gender) {
    Gender["Female"] = "FEMALE";
    Gender["Male"] = "MALE";
    Gender["Organization"] = "ORGANIZATION";
    Gender["Unknown"] = "UNKNOWN";
    Gender["Unspecified"] = "UNSPECIFIED";
})(Gender || (Gender = {}));
export var IdType;
(function (IdType) {
    IdType["NationalId"] = "NATIONAL_ID";
    IdType["Passport"] = "PASSPORT";
})(IdType || (IdType = {}));
export var JourneyType;
(function (JourneyType) {
    JourneyType["Cruise"] = "CRUISE";
    JourneyType["Oneway"] = "ONEWAY";
    JourneyType["Package"] = "PACKAGE";
    JourneyType["Return"] = "RETURN";
})(JourneyType || (JourneyType = {}));
export var MeansOfContactType;
(function (MeansOfContactType) {
    MeansOfContactType["Email"] = "EMAIL";
    MeansOfContactType["Mail"] = "MAIL";
    MeansOfContactType["Mob"] = "MOB";
    MeansOfContactType["Unknown"] = "UNKNOWN";
})(MeansOfContactType || (MeansOfContactType = {}));
export var PortCode;
(function (PortCode) {
    PortCode["Dkcph"] = "DKCPH";
    PortCode["Dkhir"] = "DKHIR";
    PortCode["Nobgo"] = "NOBGO";
    PortCode["Nokrs"] = "NOKRS";
    PortCode["Nolad"] = "NOLAD";
    PortCode["Nosvg"] = "NOSVG";
    PortCode["Notrf"] = "NOTRF";
    PortCode["Sesmd"] = "SESMD";
})(PortCode || (PortCode = {}));
export var SuggestCriteria;
(function (SuggestCriteria) {
    SuggestCriteria["Comfort"] = "COMFORT";
    SuggestCriteria["LowestFare"] = "LOWEST_FARE";
})(SuggestCriteria || (SuggestCriteria = {}));
export var SuggestItemGroup;
(function (SuggestItemGroup) {
    SuggestItemGroup["ExteriorCabins"] = "EXTERIOR_CABINS";
    SuggestItemGroup["InteriorCabins"] = "INTERIOR_CABINS";
    SuggestItemGroup["Lounges"] = "LOUNGES";
    SuggestItemGroup["Seats"] = "SEATS";
})(SuggestItemGroup || (SuggestItemGroup = {}));
export var VehicleFareCode;
(function (VehicleFareCode) {
    VehicleFareCode["Bik"] = "BIK";
    VehicleFareCode["FlVehicle_195Cm"] = "FL_VEHICLE_195_CM";
    VehicleFareCode["FlVehicle_220Cm"] = "FL_VEHICLE_220_CM";
    VehicleFareCode["FlVehicle_235Cm"] = "FL_VEHICLE_235_CM";
    VehicleFareCode["FlVehicle_450Cm"] = "FL_VEHICLE_450_CM";
    VehicleFareCode["Mc"] = "MC";
    VehicleFareCode["Mcs"] = "MCS";
})(VehicleFareCode || (VehicleFareCode = {}));
export const PortLegsDocument = gql `
    query portLegs($journeyType: JourneyType) {
  portLegs(journeyType: $journeyType) {
    originPort {
      portName
      portCode
    }
    allowedDestinations {
      portName
      portCode
    }
  }
}
    `;
/**
 * __usePortLegsQuery__
 *
 * To run a query within a React component, call `usePortLegsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortLegsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortLegsQuery({
 *   variables: {
 *      journeyType: // value for 'journeyType'
 *   },
 * });
 */
export function usePortLegsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(PortLegsDocument, options);
}
export function usePortLegsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(PortLegsDocument, options);
}
export function usePortLegsSuspenseQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(PortLegsDocument, options);
}
export const DepartureCalenderDocument = gql `
    query DepartureCalender($originPort: String!, $destinationPort: String!) {
  departures(originPort: $originPort, destinationPort: $destinationPort) {
    departureDate
  }
}
    `;
/**
 * __useDepartureCalenderQuery__
 *
 * To run a query within a React component, call `useDepartureCalenderQuery` and pass it any options that fit your needs.
 * When your component renders, `useDepartureCalenderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDepartureCalenderQuery({
 *   variables: {
 *      originPort: // value for 'originPort'
 *      destinationPort: // value for 'destinationPort'
 *   },
 * });
 */
export function useDepartureCalenderQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(DepartureCalenderDocument, options);
}
export function useDepartureCalenderLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(DepartureCalenderDocument, options);
}
export function useDepartureCalenderSuspenseQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(DepartureCalenderDocument, options);
}
export const GetPortLegsByProductCodeDocument = gql `
    query GetPortLegsByProductCode($code: String!, $lang: String) {
  journeyTypes(productCode: $code)
  promotionRules(promotionCode: $code) {
    promotionCode
    promotionStartDate
    promotionEndDate
    travelStartDate
    travelEndDate
    bannerText {
      nb
      en
      da
      nl
    }
    bannerBgColor
    bannerImageUrl
  }
  productRules(productCode: $code, language: $lang) {
    productName
    minNumPassengers
    maxNumPassengers
    allowedJourneys {
      originPort
      destinationPort
      requireReturnOnSameDay
    }
    vehiclesRequired
    vehiclesAllowed
  }
  portLegs(productCode: $code) {
    originPort {
      portCode
      portName
    }
    allowedDestinations {
      portCode
      portName
    }
  }
}
    `;
/**
 * __useGetPortLegsByProductCodeQuery__
 *
 * To run a query within a React component, call `useGetPortLegsByProductCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPortLegsByProductCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPortLegsByProductCodeQuery({
 *   variables: {
 *      code: // value for 'code'
 *      lang: // value for 'lang'
 *   },
 * });
 */
export function useGetPortLegsByProductCodeQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetPortLegsByProductCodeDocument, options);
}
export function useGetPortLegsByProductCodeLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetPortLegsByProductCodeDocument, options);
}
export function useGetPortLegsByProductCodeSuspenseQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetPortLegsByProductCodeDocument, options);
}
export const GetProductRulesDataDocument = gql `
    query GetProductRulesData($code: String!, $lang: String) {
  journeyTypes(productCode: $code)
  productRules(productCode: $code, language: $lang) {
    productName
    minNumPassengers
    maxNumPassengers
    allowedJourneys {
      originPort
      destinationPort
      requireReturnOnSameDay
    }
    vehiclesRequired
    vehiclesAllowed
  }
  portLegs(productCode: $code) {
    originPort {
      portCode
      portName
    }
    allowedDestinations {
      portCode
      portName
    }
  }
}
    `;
/**
 * __useGetProductRulesDataQuery__
 *
 * To run a query within a React component, call `useGetProductRulesDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductRulesDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductRulesDataQuery({
 *   variables: {
 *      code: // value for 'code'
 *      lang: // value for 'lang'
 *   },
 * });
 */
export function useGetProductRulesDataQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetProductRulesDataDocument, options);
}
export function useGetProductRulesDataLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetProductRulesDataDocument, options);
}
export function useGetProductRulesDataSuspenseQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetProductRulesDataDocument, options);
}
export const GetPromotionRulesDataDocument = gql `
    query GetPromotionRulesData($code: String!) {
  journeyTypes(productCode: $code)
  promotionRules(promotionCode: $code) {
    promotionCode
    promotionStartDate
    promotionEndDate
    travelStartDate
    travelEndDate
    bannerText {
      nb
      en
      da
      nl
    }
    bannerBgColor
    bannerImageUrl
  }
  portLegs(productCode: $code) {
    originPort {
      portCode
      portName
    }
    allowedDestinations {
      portCode
      portName
    }
  }
}
    `;
/**
 * __useGetPromotionRulesDataQuery__
 *
 * To run a query within a React component, call `useGetPromotionRulesDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPromotionRulesDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPromotionRulesDataQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useGetPromotionRulesDataQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetPromotionRulesDataDocument, options);
}
export function useGetPromotionRulesDataLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetPromotionRulesDataDocument, options);
}
export function useGetPromotionRulesDataSuspenseQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetPromotionRulesDataDocument, options);
}
export const CheckIfValidFlCodeDocument = gql `
    query CheckIfValidFlCode($code: String!) {
  flCode(code: $code) {
    codeValue
    codeType
    isValidCode
    __typename
  }
}
    `;
/**
 * __useCheckIfValidFlCodeQuery__
 *
 * To run a query within a React component, call `useCheckIfValidFlCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckIfValidFlCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckIfValidFlCodeQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useCheckIfValidFlCodeQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(CheckIfValidFlCodeDocument, options);
}
export function useCheckIfValidFlCodeLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(CheckIfValidFlCodeDocument, options);
}
export function useCheckIfValidFlCodeSuspenseQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(CheckIfValidFlCodeDocument, options);
}
export const CheckAvailabilityDocument = gql `
    query CheckAvailability($requestParams: AvailabilityRequestInput!) {
  availability(requestParams: $requestParams) {
    isJourneyAvailable
  }
}
    `;
/**
 * __useCheckAvailabilityQuery__
 *
 * To run a query within a React component, call `useCheckAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckAvailabilityQuery({
 *   variables: {
 *      requestParams: // value for 'requestParams'
 *   },
 * });
 */
export function useCheckAvailabilityQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(CheckAvailabilityDocument, options);
}
export function useCheckAvailabilityLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(CheckAvailabilityDocument, options);
}
export function useCheckAvailabilitySuspenseQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(CheckAvailabilityDocument, options);
}
export const GetDepartureCalendarByProductcodeDocument = gql `
    query GetDepartureCalendarByProductcode($originPort: String!, $destinationPort: String!, $productCode: String) {
  departures(
    originPort: $originPort
    destinationPort: $destinationPort
    productCode: $productCode
  ) {
    departureDate
    __typename
  }
}
    `;
/**
 * __useGetDepartureCalendarByProductcodeQuery__
 *
 * To run a query within a React component, call `useGetDepartureCalendarByProductcodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDepartureCalendarByProductcodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDepartureCalendarByProductcodeQuery({
 *   variables: {
 *      originPort: // value for 'originPort'
 *      destinationPort: // value for 'destinationPort'
 *      productCode: // value for 'productCode'
 *   },
 * });
 */
export function useGetDepartureCalendarByProductcodeQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetDepartureCalendarByProductcodeDocument, options);
}
export function useGetDepartureCalendarByProductcodeLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetDepartureCalendarByProductcodeDocument, options);
}
export function useGetDepartureCalendarByProductcodeSuspenseQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetDepartureCalendarByProductcodeDocument, options);
}
//# sourceMappingURL=types.js.map